import { c as _c } from "react/compiler-runtime";
import { ComponentProps, PropsWithChildren } from 'react';
import { DialogHeader as DialogHeaderLib } from '@material-bank/mb3-components';
type DialogHeaderProps = ComponentProps<typeof DialogHeaderLib>;
export function DialogHeader(t0) {
  const $ = _c(8);
  let children;
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
  }
  const mergedClassName = className ? `${"flex flex-col items-center gap-4"} ${className}` : "flex flex-col items-center gap-4";
  let t1;
  if ($[4] !== children || $[5] !== mergedClassName || $[6] !== rest) {
    t1 = <DialogHeaderLib className={mergedClassName} {...rest}>{children}</DialogHeaderLib>;
    $[4] = children;
    $[5] = mergedClassName;
    $[6] = rest;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}